// One-line wrapper around POST /api/messages.  Messages are persisted as
// recipient-side notifications on the server; there is no message list
// endpoint by design.

export async function sendMessage(
  token: string,
  toUserId: string,
  body: string,
): Promise<void> {
  const r = await fetch("/api/messages", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ toUserId, body }),
  });
  if (!r.ok) {
    const data = (await r.json().catch(() => null)) as
      | { error?: string }
      | null;
    throw new Error(data?.error ?? `HTTP ${r.status}`);
  }
}

export function messageErrorMessage(code: string): string {
  switch (code) {
    case "not_contacts":
      return "You can only message contacts.";
    case "self_target":
      return "You can't message yourself.";
    case "invalid_body":
      return "Message must be 1–2000 characters.";
    default:
      return code;
  }
}
